import { render, staticRenderFns } from "./PeopleInWorkflow.vue?vue&type=template&id=bf6887de"
import script from "./PeopleInWorkflow.vue?vue&type=script&lang=js"
export * from "./PeopleInWorkflow.vue?vue&type=script&lang=js"
import style0 from "./PeopleInWorkflow.vue?vue&type=style&index=0&id=bf6887de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports